import React from 'react';
import ErrorBoundary from '@atlassian/jira-error-boundary/src/ErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import { JiraIssueCreateErrorBoundary } from '@atlassian/jira-issue-create-analytics-common/src/ui/jira-issue-create-error-boundary/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const NewIssueCreateTrigger = lazyAfterPaint(
	() => import(/* webpackChunkName: "async-new-issue-create-trigger" */ './index'),
	{ ssr: false },
);

const LazyNewIssueCreateTrigger = () =>
	fg('error_boundaries_to_common_package') ? (
		<JiraIssueCreateErrorBoundary
			id="async.jira.new-issue-create-trigger"
			packageName="jiraNewIssueCreateTrigger"
		>
			<Placeholder name="new-issue-create-trigger" fallback={<></>}>
				<NewIssueCreateTrigger />
			</Placeholder>
		</JiraIssueCreateErrorBoundary>
	) : (
		<ErrorBoundary id="async.jira.new-issue-create-trigger" packageName="jiraNewIssueCreateTrigger">
			<Placeholder name="new-issue-create-trigger" fallback={<></>}>
				<NewIssueCreateTrigger />
			</Placeholder>
		</ErrorBoundary>
	);

export default LazyNewIssueCreateTrigger;
